// extracted by mini-css-extract-plugin
module.exports = {"root":"FullPageSpinner_root__2qUaB"};